module.exports = __webpack_public_path__ + "img/analytic120 2.19628cb2.svg";